import React from "react";

export default function AddPhotoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
    >
      <path
        d="M14.4049 13.8051C12.9599 13.8051 11.7849 14.9801 11.7849 16.4201C11.7849 17.8651 12.9599 19.0351 14.4049 19.0351C15.8449 19.0351 17.0199 17.8651 17.0199 16.4201C17.0186 15.7269 16.7427 15.0626 16.2525 14.5724C15.7624 14.0823 15.098 13.8064 14.4049 13.8051Z"
        fill="white"
      />
      <path
        d="M19.535 8.71501C19.065 8.71501 18.65 8.41501 18.51 7.96501L18.315 7.33501C18.1842 6.91249 17.9212 6.54309 17.5648 6.28118C17.2084 6.01926 16.7773 5.87864 16.335 5.88001H12.47C12.0278 5.87927 11.5971 6.02013 11.2408 6.28196C10.8845 6.54379 10.6214 6.91282 10.49 7.33501L10.295 7.96501C10.155 8.41501 9.74 8.71501 9.27 8.71501H5.075C3.93 8.71501 3 9.64501 3 10.79V22.05C3 23.195 3.93 24.125 5.075 24.125H23.735C24.88 24.125 25.81 23.195 25.81 22.05V12.81C25.655 12.87 25.485 12.905 25.31 12.905C24.48 12.905 23.81 12.23 23.81 11.405V10.715H23.12C22.295 10.715 21.62 10.045 21.62 9.21501C21.62 9.04001 21.66 8.87001 21.715 8.71501H19.535ZM14.405 21.51C11.6 21.51 9.315 19.225 9.315 16.42C9.315 13.615 11.6 11.335 14.405 11.335C17.21 11.335 19.49 13.615 19.49 16.42C19.49 19.225 17.21 21.51 14.405 21.51ZM25.31 6.52501C25.035 6.52501 24.81 6.75001 24.81 7.02501V8.71501H23.12C22.845 8.71501 22.62 8.94001 22.62 9.21501C22.62 9.49002 22.845 9.71501 23.12 9.71501H24.81V11.405C24.81 11.68 25.035 11.905 25.31 11.905C25.585 11.905 25.81 11.68 25.81 11.405V9.71501H27.5C27.775 9.71501 28 9.49002 28 9.21501C28 8.94001 27.775 8.71501 27.5 8.71501H25.81V7.02501C25.81 6.75001 25.585 6.52501 25.31 6.52501Z"
        fill="white"
      />
    </svg>
  );
}
